import { animateScroll as scroll } from 'react-scroll'

export const ScreenWrapper = (screenComponent: any, screen: any) => {
    scroll.scrollToTop();
    console.log(screenComponent);
    return screenComponent;
}